import React from 'react'

import { Badge } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf } from 'prop-types'

const LABELS = {
  positive: 'Subscription Active',
  attention: 'Subscription Eligible',
}

function SubscriptionTag({ type = null }) {
  const label = LABELS[type]
  if (!label) return null

  return (
    <Badge
      type={type}
      className="card-3d-model__subscription-tag"
    >
      {label}
    </Badge>
  )
}

SubscriptionTag.propTypes = {
  type: oneOf(['positive', 'attention']),
}

export default SubscriptionTag
